import React from "react";
import SuperAdminAttendance from "../superadmin/attendance/AttendancePage";

const AttendancePage = () => {
    return <SuperAdminAttendance />;
};

export default AttendancePage;
